module.exports = [{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-anchor-links@1.2.1/node_modules/gatsby-plugin-anchor-links/gatsby-browser.js'),
      options: {"plugins":[],"offset":-75},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-catch-links@5.14.0_gatsby@5.14.4_@babel+plugin-syntax-flow@7.27.1_@babel+_4e89f29661b05df23eec855e2598aafa/node_modules/gatsby-plugin-catch-links/gatsby-browser.js'),
      options: {"plugins":[],"excludePattern":"(signup|shop|store|^\\/cyclematters\\/#([a-z-]+))|^\\/cyclematters\\/$|^\\/(quiz|plan-quiz|your-birth-control-quiz|your-plan-pregnancy-quiz)"},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-react-helmet-async@1.2.3_gatsby@5.14.4_@babel+plugin-syntax-flow@7.27.1_@_7bdc30617db7f64d71b44a8376ababa0/node_modules/gatsby-plugin-react-helmet-async/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby-plugin-react-redux@1.1.0_react-redux@9.2.0_@types+react@18.3.23_react@18.3.1_redux@4.2.1__react@18.3.1/node_modules/gatsby-plugin-react-redux/gatsby-browser.js'),
      options: {"plugins":[],"pathToCreateStoreModule":"./src/store"},
    },{
      plugin: require('../gatsby-browser.ts'),
      options: {"plugins":[]},
    },{
      plugin: require('../node_modules/.pnpm/gatsby@5.14.4_@babel+plugin-syntax-flow@7.27.1_@babel+core@7.27.4__@babel+plugin-transf_d412bb8e3933f5c7164686abce6d2e63/node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
